import { action, Action } from 'typesafe-actions'

import { Anexo, FotoDocumentosTypes, S3Type } from './types'

export const setAnexosFoto = (payload: Anexo | []): Action =>
  action(FotoDocumentosTypes.SET_ANEXOS, payload)

export const deleteAnexoFoto = (payload: number): Action =>
  action(FotoDocumentosTypes.DELETE_ANEXO, payload)

export const setIsDoneFoto = (payload: boolean): Action =>
  action(FotoDocumentosTypes.SET_IS_DONE, payload)

export const setIsLoadingFoto = (payload: boolean): Action =>
  action(FotoDocumentosTypes.SET_IS_LOADING, payload)

export const setIsErrorFoto = (payload: boolean): Action =>
  action(FotoDocumentosTypes.SET_IS_ERROR, payload)

export const sendToS3Foto = (payload: S3Type): Action =>
  action(FotoDocumentosTypes.SEND_TO_S3_SAGA, payload)

export const setRollbackRouterErrorFoto = (payload: string | number | undefined): Action =>
  action(FotoDocumentosTypes.SET_ROLLBACK_ROUTER_ERROR, payload)
